import React, { useState } from 'react';
import style from './schema-layout.module.scss';
import { TabSelector } from '../../../components';
import { Entities } from './Entities';
import { Intents } from './Intents';
import { EntityValue } from './EntityValue';
import { Entity } from '../types';
import NoData from '../../../../../NoData';
import { ReactComponent as WarningIcon } from '../../../../../../../assets/svg/warningIcon.svg';
import { usePermissions } from '../../../hooks';

const tabs = [
	{ value: 'intent', label: 'Intent' },
	{ value: 'entity', label: 'Entity' },
];

function Header() {
	return (
		<div>
			<h1>Schema Layout</h1>
			<p className={style.desc}>
				Incorporate intents and entities in the schema, guiding user tasks and
				highlighting relevant terms
			</p>
		</div>
	);
}

export function SchemaLayout() {
	const [selected, setSelected] = useState('intent'); // "intent" | "entity"
	const [entity, setEntity] = useState<{
		visibility: boolean;
		data: null | Entity;
		onSave: () => void;
	}>({
		visibility: false,
		data: null,
		onSave: () => {},
	});
	const canView = usePermissions('nlu.View')

	return canView ? (
		<div
			className={style.schemaLayout}
			style={{
				display: 'grid',
				gridTemplateColumns: entity.visibility ? `1fr 360px` : '1fr',
			}}
		>
			<div className={style.main}>
				<Header />
				<TabSelector
					selected={selected}
					onSwitch={(value) => {
						setSelected(value);
						if (value === 'intent' && entity.visibility) {
							setEntity({
								data: null,
								visibility: false,
								onSave: () => {},
							});
						}
					}}
					tabs={tabs}
				/>
				{selected === 'entity' && (
					<Entities
						openEntityValue={(entity: Entity, onSave: () => void) => {
							setEntity({
								data: entity,
								visibility: true,
								onSave,
							});
						}}
					/>
				)}
				{selected === 'intent' && <Intents />}
			</div>
			{entity.visibility && entity.data !== null && (
				<EntityValue
					onSave={entity.onSave}
					entity={entity.data}
					close={() => {
						setEntity({
							data: null,
							visibility: false,
							onSave: () => {},
						});
					}}
				/>
			)}
		</div>
	) : (
		<div className="viewWrapper">
			<NoData
				svg={WarningIcon}
				header="Not Authorized"
				content="Please request owner of this organization to provide access"
				noButton={true}
			/>
		</div>
	);
}
